import { TrendingUp, TrendingDown } from "lucide-react";
import { fmtPctAbs, fmtDateBR } from "../utils/formatters";

/**
 * Banner do delta agregado (conversão visit→completed atual vs anterior).
 * Mostra também as datas dos 2 períodos comparados.
 */
export function ConversionDelta({ overallDelta, range }) {
  const positive = overallDelta >= 0;
  const Icon = positive ? TrendingUp : TrendingDown;
  const curStart = fmtDateBR(range?.current?.start);
  const curEnd = fmtDateBR(range?.current?.end, { fimExclusivo: true });
  const prevStart = fmtDateBR(range?.previous?.start);
  const prevEnd = fmtDateBR(range?.previous?.end, { fimExclusivo: true });
  const containerCls = positive
    ? "bg-gradient-to-r from-emerald-50 to-transparent dark:from-emerald-900/10 border-emerald-200/70 dark:border-emerald-800/40"
    : "bg-gradient-to-r from-red-50 to-transparent dark:from-red-900/10 border-red-200/70 dark:border-red-800/40";
  const iconCls = positive
    ? "bg-emerald-500/15 text-emerald-600"
    : "bg-red-500/15 text-red-500";

  return (
    <div className={`rounded-2xl border shadow-sm p-4 md:p-5 flex items-start md:items-center gap-3 ${containerCls}`}>
      <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${iconCls}`}>
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm leading-relaxed">
          No período analisado, a conversão do seu cardápio ficou{" "}
          <span className={positive ? "text-emerald-600 font-bold" : "text-red-500 font-bold"}>
            {fmtPctAbs(overallDelta)} {positive ? "acima" : "abaixo"}
          </span>{" "}
          em comparação ao período anterior
        </p>
        {(curStart || prevStart) && (
          <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-muted-foreground">
            {curStart && (
              <span>
                <span className="opacity-70">Atual:</span>{" "}
                <span className="font-semibold text-foreground/80 tabular-nums">
                  {curStart} → {curEnd}
                </span>
              </span>
            )}
            {prevStart && (
              <span>
                <span className="opacity-70">Anterior:</span>{" "}
                <span className="font-semibold text-foreground/80 tabular-nums">
                  {prevStart} → {prevEnd}
                </span>
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
